import { perimeterText } from 'components/perimeter/perimeterText';

const NAME_ERROR_CODES = [
  'PERIMETER_NAME_REQUIRED',
  'PERIMETER_NAME_TOO_LONG',
  'PERIMETER_NAME_TAKEN',
];

// The perimeter changed or vanished since the list was loaded: the block has
// to reload rather than let the admin retry on outdated data.
const STALE_PERIMETER_ERROR_CODES = [
  'PERIMETER_MEMBER_INVALID',
  'PERIMETER_MEMBER_NOT_RESTRICTABLE',
  'INVALID_PERIMETER_ID',
  'PERIMETER_NOT_FOUND',
  'PERIMETER_ARCHIVED',
  'PERIMETER_NOT_ARCHIVED',
  'PERIMETER_IN_USE',
  'PERIMETER_TRANSFER_INVALID',
];

const ERROR_KEYS = {
  PERIMETER_NAME_REQUIRED: 'errors.nameRequired',
  PERIMETER_NAME_TOO_LONG: 'errors.nameTooLong',
  PERIMETER_NAME_TAKEN: 'errors.nameTaken',
  PERIMETER_MEMBER_INVALID: 'errors.memberInvalid',
  PERIMETER_MEMBER_NOT_RESTRICTABLE: 'errors.memberInvalid',
  INVALID_PERIMETER_ID: 'errors.notFound',
  PERIMETER_NOT_FOUND: 'errors.notFound',
  PERIMETER_ARCHIVED: 'errors.archived',
  PERIMETER_NOT_ARCHIVED: 'errors.notArchived',
  PERIMETER_IN_USE: 'errors.inUse',
  PERIMETER_TRANSFER_INVALID: 'errors.transferInvalid',
  COMPANY_NOT_FOUND: 'errors.companyNotFound',
};

const getErrorCode = (err) => err?.response?.data?.errorCode;

// Name errors are shown under the name field, every other one in a toast.
export const isNameError = (err) =>
  NAME_ERROR_CODES.includes(getErrorCode(err));

export const isStalePerimeterError = (err) =>
  STALE_PERIMETER_ERROR_CODES.includes(getErrorCode(err));

// Archiving or deleting an already archived perimeter: the default wording
// tells to restore it before editing, which does not fit there.
export const ARCHIVE_ERROR_OVERRIDES = {
  PERIMETER_ARCHIVED: 'errors.alreadyArchived',
};

// `overrides` maps an error code to another text key.
export const getPerimeterErrorMessage = (language, err, overrides = {}) => {
  const code = getErrorCode(err);
  return perimeterText(
    language,
    overrides[code] || ERROR_KEYS[code] || 'errors.generic',
  );
};

// A request replaced by a newer one on the same url (see makeRequest): not a
// failure to report.
export const isCanceledRequest = (err) => err?.name === 'CanceledError';
